import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EnumDataset } from '../../core/enums/enum-dataset';
import { DashbordService } from './service/dashbord.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: true,
  imports: [TranslateModule],
})
export class DashboardComponent implements OnInit {
  public translate = inject(TranslateService);
  constructor(
    private DashbordService: DashbordService,

    private Router: Router
  ) {}

  token: string = sessionStorage.getItem(EnumDataset.dataSetLogin) || '';

  ngOnInit(): void {
    // if (!this.token) {
    //   this.Router.navigate(['/']);
    // }
    //this.DashbordService.preenchimentoDataSet();
  }

  public focusIn(target: HTMLElement | any): void {
    target.parentElement.classList.add('e-input-focus');
  }

  public focusOut(target: HTMLElement | any): void {
    target.parentElement.classList.remove('e-input-focus');
  }

  public onMouseDown(target: HTMLElement | any): void {
    target.classList.add('e-input-btn-ripple');
  }

  public onMouseUp(target: HTMLElement | any): void {
    let ele: HTMLElement = target;
    setTimeout(() => {
      ele.classList.remove('e-input-btn-ripple');
    }, 500);
  }
}
